import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import Pagination from '@mui/material/Pagination';
import { colors } from '../constants/styleConstants';
import { PAGINATION_VARIANTS } from '../constants/consts';

const useStyles = makeStyles()((theme, { variant }) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    '& .MuiPaginationItem-textPrimary.Mui-selected': {
      background: 'transparent',
      border: variant === PAGINATION_VARIANTS.PRIMARY ? `2px solid ${colors.blue3}` : `2px solid ${colors.primary}`,
      color: colors.textColor,
    },
  },
}));

const FbPagination = ({ variant, filters, fetchFunction, onPageChange, renderItem }) => {
  const { classes, cx } = useStyles({ variant });
  const count = Math.ceil(filters.total / filters.limit);
  const isAHrefBasedPaginationControls = typeof renderItem !== 'undefined';

  const handleChange = (event, value) => {
    fetchFunction({ limit: filters.limit, page: value });
    onPageChange();
  };

  const isEmpty = !filters.total;

  if (isEmpty) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Pagination
        count={count}
        page={filters.page}
        color="primary"
        showFirstButton
        showLastButton
        {...(!isAHrefBasedPaginationControls && { onChange: handleChange })}
        {...(isAHrefBasedPaginationControls && { renderItem })}
      />
    </div>
  );
};

FbPagination.propTypes = {
  variant: PropTypes.string,
  fetchFunction: PropTypes.func,
  onPageChange: PropTypes.func,
  filters: PropTypes.shape({
    limit: PropTypes.number,
    page: PropTypes.number,
    total: PropTypes.number,
  }),
};

FbPagination.defaultProps = {
  variant: PAGINATION_VARIANTS.SECONDARY,
  fetchFunction: () => {},
  onPageChange: () => {},
  filters: {
    limit: 20,
    page: 1,
    total: 0,
  },
};

export default FbPagination;
